
import { useCurrency } from '@/contexts/CurrencyContext';

export const useCurrencyFormat = () => {
  const { formatPrice, convertPrice, selectedCurrency, currencies } = useCurrency();

  return {
    formatPrice,
    convertPrice,
    selectedCurrency,
    currencies,
    currencySymbol: selectedCurrency.symbol,
    currencyCode: selectedCurrency.code
  };
};
